import * as React from 'react';
import * as classNames from 'classnames';

import RQLPills from './rql_pills';

import { Filter, WidgetType } from './search_filters';
import SearchControls from './search_controls';

interface IProps {
  filters: Filter[];
  total?: number;
  followButton?: React.ReactNode;
  tipText?: string;
  totalText?: string;
  loading?: boolean;
  showSearchControls?: boolean;
}

export default class RQLSearchOverview extends React.Component<IProps, null> {
  render() {
    const sort = this.props.filters.find(filter => filter.widgetType === WidgetType.SORT);
    const classes = classNames(
      'search-overview',
      { 'search-overview--loading': this.props.loading },
    );

    return (
      <nav className={classes}>
        <section className="search-overview__primary">
          <div className="search-overview__count">
            {!this.props.loading &&
              <h2>
                {this.props.totalText}
              </h2>
            }
            {this.props.tipText &&
              <p className="mb-0 size-70">
                {this.props.tipText}
              </p>
            }
          </div>
          <div className="search-overview__feed">
            {this.props.followButton}
          </div>
        </section>
        <div className="search-overview__secondary">
          <div className="search-overview__filters">
            <RQLPills filters={this.props.filters} />
          </div>
          <div className="search-overview__controls">
            <SearchControls sort={sort} showSearchControls={this.props.showSearchControls} />
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/rql_search_overview.tsx